import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
export const SubFamilyProductSkeleton = ({ count = 1 }) => {
  return (
    <div className="col-sm-12 col-md-12 col-lg-12 mt-3 mt-lg-4">
      {[...Array(count)].map((_, index) => (
        <div
          className="search-row rowProducts-list position-relative"
          key={index}
        >
          <div className="row">
            {/* Left Side: Product Info */}
            <div className="col-md-12 col-lg-7">
              <div className="row">
                <div className="col-md-3 col-lg-3 row-pro-img">
                  <Skeleton height={100} />
                </div>
                <div className="col-md-9 col-lg-9">
                  <h6 className="product-title">
                    <Skeleton width={`80%`} />
                  </h6>
                  <div className="row-product-features product-features">
                    <h6>
                      <Skeleton width={80} />
                    </h6>
                    <div className="proTech-details">
                      {[...Array(3)].map((_, idx) => (
                        <div className="proTech-details-info" key={idx}>
                          <div className="specs-heading">
                            <h5>
                              <Skeleton width={`60%`} />
                            </h5>
                          </div>
                          <div className="specs-details">
                            <p>
                              <Skeleton width={`50%`} />
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side: Price & Icons */}
            <div className="col-md-12 col-lg-5 text-end row-productListing">
              <div className="row-price">
                <p>
                  <Skeleton width={80} />
                </p>
              </div>
              <div
                className="product-code-availability"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "end",
                  gap: "10px",
                }}
              >
                <span>
                  Code:{"  "} <Skeleton width={100} />
                </span>
                <span className="proAvailablity">
                  Availability:{" "}
                  <span className="cc-pro-available">
                    <Skeleton width={60} />
                  </span>
                </span>
              </div>

              <div className="row-products-info mt-3">
                <div className="product-adding-icons rowProducts-addingIcons d-flex gap-2 justify-content-end">
                  {[...Array(3)].map((_, index) => (
                    <div key={index} style={{ width: 32, height: 32 }}>
                      <Skeleton circle height={32} width={32} />
                    </div>
                  ))}
                </div>

                <div className="rowProduct-qty product-quantity d-flex justify-content-end">
                  <div className="qty-container d-flex align-items-center gap-2">
                    <Skeleton width={180} height={40} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
